(function () {
  'use strict';
  if (window.LDNativeProductMetadata) {
    window.LDNativeProductMetadata.hydrate(document);
    return;
  }
  var selector = 'script[type="application/json"][data-ld-native-product]';
  var maxProducts = 4096;
  var maxVariants = 16384;
  var processed = new WeakSet();
  var activeProducts;
  var activeLength = 0;
  var productIndex = new Map();
  var variantIds = new Set();
  var variantCount = 0;

  function positiveId(value) {
    return Number.isSafeInteger(value) && value > 0;
  }
  function idKey(value) {
    return positiveId(Number(value)) ? String(Number(value)) : '';
  }
  function nullableString(value) {
    return value === null || typeof value === 'string' && value.length <= 2048;
  }
  function validProduct(product) {
    return product && positiveId(product.id) && product.gid === 'gid://shopify/Product/' + product.id &&
      typeof product.vendor === 'string' && product.vendor.length <= 2048 &&
      typeof product.type === 'string' && product.type.length <= 2048 &&
      Array.isArray(product.variants) && product.variants.length > 0 && product.variants.length <= 100 &&
      product.variants.every(function (variant) {
        return variant && positiveId(variant.id) && Number.isSafeInteger(variant.price) && variant.price >= 0 &&
          typeof variant.name === 'string' && variant.name.length <= 2048 &&
          nullableString(variant.sku) && nullableString(variant.public_title);
      });
  }
  function productsFor(meta) {
    if (meta.products === undefined) {
      meta.products = meta.product && idKey(meta.product.id) ? [meta.product] : [];
    }
    if (!Array.isArray(meta.products)) return null;
    var products = meta.products;
    if (products !== activeProducts || products.length !== activeLength) {
      activeProducts = products;
      activeLength = products.length;
      processed = new WeakSet();
      productIndex = new Map();
      variantIds = new Set();
      variantCount = 0;
      products.slice(0, maxProducts).forEach(function (product) {
        if (!product || !idKey(product.id)) return;
        if (!productIndex.has(idKey(product.id))) productIndex.set(idKey(product.id), product);
        if (Array.isArray(product.variants)) {
          variantCount += product.variants.length;
          product.variants.forEach(function (variant) {
            if (variant && idKey(variant.id) && variantIds.size < maxVariants) variantIds.add(idKey(variant.id));
          });
        }
      });
    }
    return products;
  }
  function mergeNode(node) {
    var data;
    if (!node.textContent || node.textContent.length > 32768) return 0;
    try { data = JSON.parse(node.textContent); } catch (_) { processed.add(node); return 0; }
    if (!data || !validProduct(data.product)) { processed.add(node); return 0; }
    var analytics = window.ShopifyAnalytics = window.ShopifyAnalytics || {};
    var meta = analytics.meta = analytics.meta || {};
    if (data.currency && meta.currency && data.currency !== meta.currency) return 0;
    var products = productsFor(meta);
    if (!products || processed.has(node)) return 0;
    processed.add(node);
    var source = data.product;
    var target = productIndex.get(idKey(source.id));
    var added = 0;
    if (!target) {
      if (products.length >= maxProducts || variantCount >= maxVariants) return 0;
      target = { id: source.id, gid: source.gid, vendor: source.vendor, type: source.type, variants: [] };
      products.push(target);
      productIndex.set(idKey(source.id), target);
      activeLength = products.length;
    }
    if (target.variants === undefined) target.variants = [];
    if (!Array.isArray(target.variants)) return 0;
    var known = new Set(target.variants.map(function (variant) { return variant && idKey(variant.id); }));
    source.variants.forEach(function (variant) {
      var key = idKey(variant.id);
      if (known.has(key) || variantIds.has(key) || variantCount >= maxVariants) return;
      target.variants.push({ id: variant.id, price: variant.price, name: variant.name, sku: variant.sku, public_title: variant.public_title });
      known.add(key);
      variantIds.add(key);
      variantCount++;
      added++;
    });
    return added;
  }
  function hydrate(scope) {
    if (!scope) return 0;
    var nodes = scope.matches && scope.matches(selector) ? [scope] : [];
    if (scope.querySelectorAll) nodes = nodes.concat(Array.from(scope.querySelectorAll(selector)));
    var added = 0;
    nodes.forEach(function (node) {
      try { added += mergeNode(node); } catch (_) {}
    });
    return added;
  }
  window.LDNativeProductMetadata = { hydrate: hydrate };
  hydrate(document);
  window.addEventListener('load', function () { hydrate(document); }, { once: true });
  document.addEventListener('shopify:section:load', function (event) { hydrate(event.target); });
  if (window.MutationObserver && document.documentElement) {
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 || node.nodeType === 11) hydrate(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
